module.exports = __webpack_public_path__ + "img/features-split-image-01.c54ce779.jpg";